// Static data for About Us page

import { FaHeart, FaLeaf, FaHandshake, FaLightbulb } from 'react-icons/fa';

export const coreValues = [
  {
    icon: <FaHeart size={40} />,
    title: 'Passion for Quality',
    description: "We're passionate about delivering the finest quality products that exceed expectations.",
  },
  {
    icon: <FaLeaf size={40} />,
    title: 'Sustainability',
    description: 'Committed to sustainable practices in sourcing and packaging.',
  },
  {
    icon: <FaHandshake size={40} />,
    title: 'Trust & Integrity',
    description: 'Building lasting relationships through transparency and honest business practices.',
  },
  {
    icon: <FaLightbulb size={40} />,
    title: 'Innovation',
    description: 'Continuously innovating to bring you better products and experiences.',
  },
];

export const journeyData = [
  {
    year: '2020',
    description: 'Founded with a vision to revolutionize ready-to-cook products',
  },
  {
    year: '2021',
    description: 'Launched our signature marinated chicken product line',
  },
  {
    year: '2022',
    description: 'Expanded to fruit pulps and received FSSAI certification',
  },
  {
    year: '2023',
    description: 'Established nationwide presence and launched export operations',
  },
];

export const brand = {
  logo: '/media/venlins-logo.webp',
  name: "Venlin's Foods",
};

export const certifications = [
  {
    img: '/media/fssai.webp',
    label: 'FSSAI Certified',
  },
  {
    img: '/media/iso.webp',
    label: 'ISO 22000:2018',
  },
  {
    img: '/media/haccp.webp',
    label: 'HACCP Certified',
  },
]; 